<section class="product-details-skeleton">
  <div class="product-details-skeleton__options">
    <ngx-skeleton-loader
      count="1"
      class="product-details-skeleton__breadcrumbs"
      [theme]="{
        height: '1.875em',
        width: '18em',
        margin: '0',
      }"></ngx-skeleton-loader>
    <div class="product-details-skeleton__menu-actions" aria-hidden="true">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '2.5em',
          width: '2.5em',
          margin: '0',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '2.5em',
          width: '2.5em',
          margin: '0',
        }"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="product-details-skeleton__surface">
    <div class="product-details-skeleton__preview">
      <div class="product-details-skeleton__media">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '100%',
            width: '100%',
            'border-radius': '0.5rem'
          }"></ngx-skeleton-loader>
      </div>

      <div class="product-details-skeleton__preview-content">
        <div class="product-details-skeleton__headline">
          <div class="product-details-skeleton__title-text">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '1.35em',
                width: '72%',
                'max-width': '28em',
                margin: '0'
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '1em',
                width: '48%',
                'max-width': '18em',
                margin: '0.25em 0 0'
              }"></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '2.5em',
              width: '2.5em',
              'border-radius': '50%',
              margin: '0',
              flexShrink: '0'
            }"></ngx-skeleton-loader>
        </div>

        <ngx-skeleton-loader
          count="4"
          appearance="line"
          [theme]="{
            height: '0.625em',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25em'
          }"></ngx-skeleton-loader>

        <div class="product-details-skeleton__properties" aria-hidden="true">
          @for (property of propertySkeletonItems; track property) {
            <div class="product-details-skeleton__property">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  height: '2.45em',
                  width: '2.45em',
                  margin: '0',
                }"></ngx-skeleton-loader>
              <ngx-skeleton-loader
                count="2"
                [theme]="{
                  height: '0.625em',
                  width: '3.125em',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.5em',
                  margin: '0',
                }"></ngx-skeleton-loader>
            </div>
          }
        </div>

        <div class="product-details-skeleton__price-action">
          <div class="product-details-skeleton__price">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{
                width: '2.2em',
                height: '0.625em'
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{
                width: '6.5em',
                height: '0.625em'
              }"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="product-details-skeleton__surface product-details-skeleton__surface--compact">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '2.5em',
        width: '100%',
        'border-radius': '0.625em'
      }"></ngx-skeleton-loader>
  </div>

  <div class="product-details-skeleton__sticky-nav">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '3.5em',
        width: '100%',
        'border-radius': '0.625em'
      }"></ngx-skeleton-loader>
  </div>

  <div class="product-details-skeleton__surface">
    <div class="product-details-skeleton__section-block">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '1.875em',
          width: '6.5em'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="4"
        appearance="line"
        [theme]="{
          height: '0.625em',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.35em'
        }"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="product-details-skeleton__surface">
    <div class="product-details-skeleton__section-block">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '1.875em',
          width: '5.25em'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '25em',
          'border-radius': '0.75em'
        }"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="product-details-skeleton__surface">
    <div class="product-details-skeleton__section-block">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '1.875em',
          width: '9em'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '12em',
          'border-radius': '0.75em'
        }"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="product-details-skeleton__surface">
    <div class="product-details-skeleton__section-block">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '1.875em',
          width: '11em'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '12em',
          'border-radius': '0.75em'
        }"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="product-details-skeleton__surface">
    <div class="product-details-skeleton__section-block">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '1.875em',
          width: '6em'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="3"
        [theme]="{
          height: '3.5em',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75em',
          'border-radius': '0.75em'
        }"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="product-details-skeleton__surface">
    <div class="product-details-skeleton__section-block">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '1.875em',
          width: '7em'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="3"
        [theme]="{
          height: '5em',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75em',
          'border-radius': '0.75em'
        }"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="product-details-skeleton__surface">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '12em',
        width: '100%',
        'border-radius': '0.75em'
      }"></ngx-skeleton-loader>
  </div>

  <div class="product-details-skeleton__surface">
    <ngx-skeleton-loader
      count="2"
      [theme]="{
        height: '4.5em',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75em',
        'border-radius': '0.75em'
      }"></ngx-skeleton-loader>
  </div>
</section>
